module.exports = __webpack_public_path__ + "img/btn_shitu_hou.fe6591c1.png";